import { ExportListComponent } from './components/directory-tree/components/export-list/export-list.component';
import { MaterialRoutingWrapperComponent } from './components/packaging-component-material/create-update/common/material-routing-wrapper/material-routing-wrapper.component';
import { CreateUpdateMainBodyComponent } from './components/packaging-component/create-update/create-update-main-body/create-update-main-body.component';
import { MaterialHomeComponent } from './components/packaging-component-material/material-home/material-home.component';
import { ViewAggregateEvaluationsComponent } from './components/analyses/aggregate-evaluations/view-aggregate-evaluations/view-aggregate-evaluations.component';
import { exportProfilesResolver } from './data-transfer/resolvers/export-profile-resolver';
import { ExportProfilesComponent } from './components/directory-tree/components/export-profiles/export-profiles/export-profiles.component';
import { ChangelogComponent } from './components/various-components/changelog/changelog.component';
import { DirectoryManagementComponent } from './components/directory-tree/components/directory-management/directory-management.component';
import { OrganizationManagementComponent } from './components/various-components/organization-management/organization-management.component';
import { HomepageComponent } from './components/various-components/homepage/homepage.component';
import { CreateUpdatePackagingAidComponent } from './components/packaging-component/create-update/create-update-packaging-aid/create-update-packaging-aid.component';
import { CreateUpdateDecorationComponent } from './components/packaging-component/create-update/create-update-decoration/create-update-decoration.component';
import { ComponentHomeComponent } from './components/packaging-component/component-home/component-home.component';
import { CreateUpdateInlayComponent } from './components/packaging-component/create-update/create-update-inlay/create-update-inlay.component';
import { ComparePackagingUnitsComponent } from './components/packaging-unit/compare/compare-packaging-units.component';
import { AnalysisLifeCycleComponent } from './components/analyses/analysis-life-cycle/analysis-life-cycle.component';
import { AnalysisCradleToGateLifeCycleComponent } from './components/analyses/analysis-cradle-to-gate-life-cycle/analysis-cradle-to-gate-life-cycle.component';
import { CreateUpdatePackagingUnitComponent } from './components/packaging-unit/create-update/create-update-packaging-unit/create-update-packaging-unit.component';
import { PackagingRoutingWrapperComponent } from './components/packaging-unit/create-update/common/packaging-routing-wrapper/packaging-routing-wrapper.component';
import { UserManagementComponent } from './components/various-components/user-management/user-management.component';
import { ErrorPageComponent } from './components/various-components/error-page/error-page.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './components/various-components/login/login.component';
import { unsavedChangesGuard } from './services/unsaved-changes-guard';
import { PathResolveService } from './services/path-resolve.service';
import { PackagingUnitHomeComponent } from './components/packaging-unit/packaging-unit-home/packaging-unit-home.component';
import { AppNavComponent } from './navigation/components/app-nav/app-nav.component';
import { directoryResolver } from './data-transfer/resolvers/directory-resolver';
import { CreateUpdateClosureComponent } from './components/packaging-component/create-update/create-update-closure/create-update-closure.component';
import { DependenciesComponent } from './components/various-components/dependencies/dependencies.component';
import { ValidatorViewComponent } from './components/various-components/validator-view/validator-view.component';
import { ComponentRoutingWrapperComponent } from './components/packaging-component/create-update/common/component-routing-wrapper/component-routing-wrapper.component';
import { PerformAggregateEvaluationsComponent } from './components/analyses/aggregate-evaluations/perform-aggregate-evaluations/perform-aggregate-evaluations.component';
import { CompositeMaterialComponent } from './components/packaging-component-material/create-update/composite-material/composite-material.component';
import { ReportTemplateWizardComponent } from './components/reports/templates/report-template-wizard/report-template-wizard.component';
import { TagsManagementComponent } from './components/various-components/tags/tags-management/tags-management.component';
import { LcaDataExcelImportComponent } from './components/shared-components/upload/lca-data-excel-import/lca-data-excel-import.component';
import { CreateUpdatePackagingSystemComponent } from './components/packaging-system/create-update/create-update-packaging-system/create-update-packaging-system.component';
import { PackagingSystemHomeComponent } from './components/packaging-system/packaging-system-home/packaging-system-home.component';
import { ReportTemplatesHomeComponent } from './components/reports/templates/report-templates-home/report-templates-home.component';
import { ReportsHomeComponent } from './components/reports/reports-home/reports-home.component';
import { aggregatedRecyclabilityResolver, aggregatedLifecycleResolver } from './data-transfer/resolvers/aggregated-analysis-resolver';
import { usersResolver, organizationsResolver, userGroupsResolver, billingAccountsResolver } from './data-transfer/resolvers/user-data-resolver';
import {
  reportTemplateComponentResolver,
  reportTemplatePackagingUnitResolver,
  reportTemplatePackagingSystemResolver,
  reportTemplatesComponentResolver,
  reportTemplatesPackagingSystemResolver,
  reportTemplatesPackagingUnitResolver,
  reportsComponentResolver,
  reportsPackagingUnitResolver,
  reportsPackagingSystemResolver,
} from './data-transfer/resolvers/report-resolver';
import {
  componentResolver,
  componentPermissionsResolver,
  componentHistoryResolver,
  componentTypesEngResolver,
  componentTypesResolver,
  lastViewedComponentsResolver,
  componentPreviewResolver,
  decorationPreviewResolver,
  decorationSubtypesEngResolver,
  decorationSubtypesResolver,
  closureSubtypesResolver,
  inlaySubtypesResolver,
  mainBodySubtypesResolver,
  packagingAidSubtypesResolver,
  dataExchangeRequestPackagingComponentResolver,
  getOngoingDataExchangeRequestsForPackagingComponentResolver,
  isComponentInternallyTrackedResolver,
} from './data-transfer/resolvers/component-resolver';
import {
  allPackagingUnitsResolver,
  packagingUnitResolver,
  packagingUnitHistoryResolver,
  packagingUnitTypesEngResolver,
  packagingUnitTypesResolver,
  lastViewedPackagingUnitsResolver,
  multiplePackagingUnitsResolver,
  packagingUnitPreviewResolver,
  changedComponentsResolver,
  dataExchangeRequestPackagingUnitResolver,
  packagingUnitPermissionsResolver,
  getOngoingDataExchangeRequestsForPackagingUnitResolver,
} from './data-transfer/resolvers/packaging-unit-resolver';
import {
  allPackagingSystemsResolver,
  changedSystemsResolver,
  changedUnitsResolver,
  lastViewedPackagingSystemsResolver,
  multiplePackagingSystemsResolver,
  packagingSystemHistoryResolver,
  packagingSystemPermissionsResolver,
  packagingSystemPreviewResolver,
  packagingSystemResolver,
  dataExchangeRequestPackagingSystemResolver,
  getOngoingDataExchangeRequestsForPackagingSystemResolver,
} from './data-transfer/resolvers/packaging-system-resolver';
import {
  lastViewedMaterialsResolver,
  compositeMaterialResolver,
  compositeMaterialPermissionsResolver,
  compositeMaterialHistoryResolver,
  compositeMaterialPreviewResolver,
  dataExchangeRequestMultiMaterialResolver,
  getOngoingDataExchangeRequestsForMultiMaterialResolver,
  isMaterialInternallyTrackedResolver,
} from './data-transfer/resolvers/material-resolver';
import {
  fillingGoodsResolver,
  fillingGoodCategoriesResolver,
  fillingGoodTypesResolver,
  removabilityConditionsResolver,
  materialFunctionsResolver,
  colorsResolver,
  manifestationsResolver,
  distributionCountriesResolver,
  assemblyCountriesResolver,
  manufacturingCountriesResolver,
  allCountriesResolver,
  allCountriesEngResolver,
  certificateTypesResolver,
} from './data-transfer/resolvers/base-data-resolver';
import { errorCodeResolver } from './data-transfer/resolvers/error-code-resolver';
import { errorPathResolver } from './data-transfer/resolvers/error-path-resolver';
import { allTagsResolver } from './data-transfer/resolvers/tag-resolver';
import { InternationalInfosComponent } from './components/various-components/international-infos/international-infos.component';
import { authGuard } from './services/auth-guard';
import { ppwrAllowedGuard } from './services/ppwr-allowed-guard';
import {
  lcaComparisonResolverSystem,
  lcaComparisonResolverUnit,
  lifeCycleEvaluationHistoryResolverSystem,
  lifeCycleEvaluationHistoryResolverUnit,
  recyclabilityComparisonResolverSystem,
  recyclabilityComparisonResolverUnit,
  recyclabilityEvaluationHistoryResolverSystem,
  recyclabilityEvaluationHistoryResolverUnit,
  expenseCalculationHistoryResolverUnit,
  expenseCalculationHistoryResolverSystem,
  recyclingStreamsResolver,
  lifeCycleCradleToGateEvaluationHistoryResolverSystem,
  lifeCycleCradleToGateEvaluationHistoryResolverUnit,
  licenseFeeCountriesResolver,
  ecomodulationCountriesResolver,
  plasticTaxCountriesResolver,
  compareUnitsResolver,
} from './data-transfer/resolvers/analysis-resolver';
import { AnalysisRecyclabilityComponent } from './components/analyses/analysis-recyclability/analysis-recyclability.component';
import { ComparePackagingSystemsComponent } from './components/packaging-system/compare/compare-packaging-systems.component';
import { CLOSURE_NAME } from './model/components/closure-component';
import { DECORATION_NAME } from './model/components/decoration-component';
import { INLAY_NAME } from './model/components/inlay-component';
import { MAIN_BODY_NAME } from './model/components/main-body-component';
import { PACKAGING_AID_NAME } from './model/components/packaging-aid-component';
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { exportListResolver } from './data-transfer/resolvers/export-list-resolver';
import { ExpenseCalculationPackagingUnitComponent } from './components/analyses/expense-calculation-packaging-unit/expense-calculation-packaging-unit.component';
import { ExpenseCalculationPackagingSystemComponent } from './components/analyses/expense-calculation-packaging-system/expense-calculation-packaging-system.component';
import { ImportPackagingComponent } from './components/directory-tree/components/import/import-packaging/import-packaging.component';
import { GS1DataTransferComponent } from './components/directory-tree/components/gs1-data-transfer/gs1-data-transfer.component';
import { DataExchangeRequestsComponent } from './components/directory-tree/components/data-exchange-requests/data-exchange-requests.component';
import { OrganizationSettingsComponent } from './components/various-components/organization-settings/organization-settings.component';
import { ProfilesComponent } from './components/various-components/profiles/profiles.component';
import { ownOrganizationResolver } from './data-transfer/resolvers/base-data-resolver';

const routes: Routes = [
  {
    path: '',
    redirectTo: PathResolveService.getCockpitPath(),
    pathMatch: 'full',
  },
  {
    path: PathResolveService.getLoginPath(),
    component: LoginComponent,
    canActivate: [authGuard],
  },
  {
    path: PathResolveService.getCockpitPath(),
    component: AppNavComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: PathResolveService.getStartPath(),
        pathMatch: 'full',
      },
      {
        path: 'landing-page',
        component: LandingPageComponent,
      },
      {
        path: PathResolveService.getStartPath(),
        component: HomepageComponent,
        canActivate: [authGuard],
        resolve: {
          lastViewedPackagingSystems: lastViewedPackagingSystemsResolver,
          lastViewedPackagingUnits: lastViewedPackagingUnitsResolver,
          lastViewedComponents: lastViewedComponentsResolver,
          lastViewedMaterials: lastViewedMaterialsResolver,
        },
      },
      {
        path: PathResolveService.getUserManagementPath(),
        component: UserManagementComponent,
        canActivate: [authGuard],
        resolve: { users: usersResolver },
      },
      {
        path: PathResolveService.getDependencyVersionsPath(),
        component: DependenciesComponent,
        canActivate: [authGuard],
      },
      {
        path: PathResolveService.getUiChangelogPath(),
        component: ChangelogComponent,
        canActivate: [authGuard],
      },
      {
        path: PathResolveService.getExportProfilesPath(),
        component: ExportProfilesComponent,
        canActivate: [authGuard],
        resolve: { profiles: exportProfilesResolver },
      },
      {
        path: PathResolveService.getExportListPath(),
        component: ExportListComponent,
        canActivate: [authGuard],
        resolve: { exportLists: exportListResolver },
      },
      {
        path: PathResolveService.getGS1DataTransferPath(),
        component: GS1DataTransferComponent,
        canActivate: [authGuard],
        resolve: {
          allTags: allTagsResolver,
        },
      },
      {
        path: PathResolveService.getOrganizationsManagementPath(),
        component: OrganizationManagementComponent,
        canActivate: [authGuard],
        resolve: {
          allOrganizations: organizationsResolver,
          allUserGroups: userGroupsResolver,
          allUsers: usersResolver,
          allBillingAccounts: billingAccountsResolver,
        },
      },
      {
        path: PathResolveService.getLcaDataExcelImportPath(),
        component: LcaDataExcelImportComponent,
        canActivate: [authGuard],
      },
      {
        path: PathResolveService.getTagsManagementPath(),
        component: TagsManagementComponent,
        canActivate: [authGuard],
        resolve: {
          allTags: allTagsResolver,
        },
      },
      {
        path: PathResolveService.getOrganisationSettingsPath(),
        component: OrganizationSettingsComponent,
        canActivate: [authGuard],
        resolve: {
          allCountries: allCountriesResolver,
          ownOrganization: ownOrganizationResolver,
        },
      },
      {
        path: PathResolveService.getProfilesPath(),
        component: ProfilesComponent,
        canActivate: [authGuard, ppwrAllowedGuard],
      },
      {
        path: PathResolveService.getValidatorViewSystems(),
        component: ValidatorViewComponent,
        canActivate: [authGuard],
        resolve: {
          allPackagingParts: allPackagingSystemsResolver,
        },
      },
      {
        path: PathResolveService.getValidatorViewUnits(),
        component: ValidatorViewComponent,
        canActivate: [authGuard],
        resolve: {
          allPackagingParts: allPackagingUnitsResolver,
        },
      },
      {
        path: PathResolveService.getDirectoryManagementPath(),
        component: DirectoryManagementComponent,
        runGuardsAndResolvers: 'always',
        canActivate: [authGuard],
        data: {
          reloadComponent: true,
        },
        resolve: {
          rootDtoDirectory: directoryResolver,
          allTags: allTagsResolver,
        },
      },
      {
        path: PathResolveService.getPackagingImportPathWithoutParameters(),
        redirectTo: PathResolveService.getPackagingImportPath(false, true),
        pathMatch: 'full',
      },
      {
        path: PathResolveService.getPackagingImportPath(),
        component: ImportPackagingComponent,
        canActivate: [authGuard],
      },
      {
        path: PathResolveService.getDataExchangeRequestsPath(),
        component: DataExchangeRequestsComponent,
        canActivate: [authGuard],
      },
      {
        path: PathResolveService.getPerformEvaluationPath(),
        component: PerformAggregateEvaluationsComponent,
        canActivate: [authGuard],
        resolve: {
          allPackagingSystems: allPackagingSystemsResolver,
          allCountries: distributionCountriesResolver,
          allTags: allTagsResolver,
        },
      },
      {
        path: PathResolveService.getViewEvaluationPath(),
        component: ViewAggregateEvaluationsComponent,
        canActivate: [authGuard],
        resolve: {
          allAggregatedRecEvaluations: aggregatedRecyclabilityResolver,
          allAggregatedLcaEvaluations: aggregatedLifecycleResolver,
        },
      },
      {
        path: PathResolveService.getReportTemplatesHomePath(),
        component: ReportTemplatesHomeComponent,
        canActivate: [authGuard],
        resolve: {
          PackagingSystemReportTemplates: reportTemplatesPackagingSystemResolver,
          packagingUnitReportTemplates: reportTemplatesPackagingUnitResolver,
          componentReportTemplates: reportTemplatesComponentResolver,
        },
      },
      {
        path: PathResolveService.getReportsHomePath(),
        component: ReportsHomeComponent,
        canActivate: [authGuard],
        resolve: {
          packagingSystemReports: reportsPackagingSystemResolver,
          packagingUnitReports: reportsPackagingUnitResolver,
          componentReports: reportsComponentResolver,
        },
      },
      {
        path: PathResolveService.getCreatePackagingSystemReportTemplatePath(),
        component: ReportTemplateWizardComponent,
        canActivate: [authGuard],
      },
      {
        path: PathResolveService.getUpdatePackagingSystemReportTemplatePath(),
        component: ReportTemplateWizardComponent,
        canActivate: [authGuard],
        resolve: {
          reportTemplate: reportTemplatePackagingSystemResolver,
        },
      },
      {
        path: PathResolveService.getCreatePackagingUnitReportTemplatePath(),
        component: ReportTemplateWizardComponent,
        canActivate: [authGuard],
      },
      {
        path: PathResolveService.getUpdatePackagingUnitReportTemplatePath(),
        component: ReportTemplateWizardComponent,
        canActivate: [authGuard],
        resolve: {
          reportTemplate: reportTemplatePackagingUnitResolver,
        },
      },
      {
        path: PathResolveService.getCreateComponentReportTemplatePath(),
        component: ReportTemplateWizardComponent,
        canActivate: [authGuard],
      },
      {
        path: PathResolveService.getUpdateComponentReportTemplatePath(),
        component: ReportTemplateWizardComponent,
        canActivate: [authGuard],
        resolve: {
          reportTemplate: reportTemplateComponentResolver,
        },
      },
      {
        path: PathResolveService.getCreateMaterialReportTemplatePath(),
        component: ReportTemplateWizardComponent,
        canActivate: [authGuard],
      },
      {
        path: PathResolveService.getUpdateMaterialReportTemplatePath(),
        component: ReportTemplateWizardComponent,
        canActivate: [authGuard],
      },
      {
        path: PathResolveService.getInternationalInfosPath(),
        component: InternationalInfosComponent,
        canActivate: [authGuard],
        resolve: {
          allCountries: allCountriesResolver,
        },
      },
      {
        path: 'packaging',
        component: MaterialRoutingWrapperComponent,
        canActivate: [authGuard],
        data: {
          reloadComponent: true,
        },
        children: [
          {
            path: 'packaging-system',
            component: PackagingRoutingWrapperComponent,
            canActivate: [authGuard],
            children: [
              {
                path: '',
                redirectTo: PathResolveService.getPackagingSystemHomepagePath(),
                pathMatch: 'full',
              },
              {
                path: PathResolveService.getPackagingSystemHomepagePath(),
                component: PackagingSystemHomeComponent,
                canActivate: [authGuard],
              },
              {
                path: 'create',
                component: CreateUpdatePackagingSystemComponent,
                canDeactivate: [unsavedChangesGuard],
              },
              {
                path: 'update/:id',
                runGuardsAndResolvers: 'always',
                component: CreateUpdatePackagingSystemComponent,
                resolve: {
                  packagingSystem: packagingSystemResolver,
                  changedSystemIds: changedSystemsResolver,
                  changedUnitIds: changedUnitsResolver,
                  permissions: packagingSystemPermissionsResolver,
                  isInOngoingDataExchange: getOngoingDataExchangeRequestsForPackagingSystemResolver,
                },
                canDeactivate: [unsavedChangesGuard],
              },
              {
                path: 'update/:id/:versionId',
                runGuardsAndResolvers: 'always',
                component: CreateUpdatePackagingSystemComponent,
                resolve: {
                  packagingSystem: packagingSystemHistoryResolver,
                  changedSystemIds: changedSystemsResolver,
                  changedUnitIds: changedUnitsResolver,
                  permissions: packagingSystemPermissionsResolver,
                  isInOngoingDataExchange: getOngoingDataExchangeRequestsForPackagingSystemResolver,
                },
                canDeactivate: [unsavedChangesGuard],
              },
              ...PathResolveService.getAllPackagingSystemPreviewPaths().map(path => ({
                path,
                component: CreateUpdatePackagingSystemComponent,
                canDeactivate: [unsavedChangesGuard],
                resolve: {
                  packagingSystem: packagingSystemPreviewResolver,
                },
              })),
              {
                path: PathResolveService.getDataExchangeRequestPackagingSystemPath(),
                component: CreateUpdatePackagingSystemComponent,
                runGuardsAndResolvers: 'always',
                canDeactivate: [unsavedChangesGuard],
                data: { isDataExchangeSubRequest: true },
                resolve: {
                  dataExchangeRequest: dataExchangeRequestPackagingSystemResolver,
                },
              },
            ],
            resolve: {
              fillingGoods: fillingGoodsResolver,
              fillingGoodCategories: fillingGoodCategoriesResolver,
              fillingGoodTypes: fillingGoodTypesResolver,
              assemblyCountries: assemblyCountriesResolver,
              mainBodySubtypes: mainBodySubtypesResolver,
              closureSubtypes: closureSubtypesResolver,
              decorationSubtypes: decorationSubtypesResolver,
              inlaySubtypes: inlaySubtypesResolver,
              packagingAidSubtypes: packagingAidSubtypesResolver,
              removabilityConditions: removabilityConditionsResolver,
            },
          },
          {
            path: 'packaging-unit',
            component: PackagingRoutingWrapperComponent,
            canActivate: [authGuard],
            children: [
              {
                path: '',
                redirectTo: PathResolveService.getPackagingUnitHomepagePath(),
                pathMatch: 'full',
              },
              {
                path: PathResolveService.getPackagingUnitHomepagePath(),
                component: PackagingUnitHomeComponent,
                canActivate: [authGuard],
              },
              {
                path: PathResolveService.getPackagingUnitTypePath(),
                component: PackagingUnitHomeComponent,
                canActivate: [authGuard],
              },
              {
                path: 'create',
                component: CreateUpdatePackagingUnitComponent,
                canDeactivate: [unsavedChangesGuard],
              },
              {
                path: 'update/:id',
                runGuardsAndResolvers: 'always',
                component: CreateUpdatePackagingUnitComponent,
                resolve: {
                  packagingUnit: packagingUnitResolver,
                  changedComponentsIds: changedComponentsResolver,
                  permissions: packagingUnitPermissionsResolver,
                  isInOngoingDataExchange: getOngoingDataExchangeRequestsForPackagingUnitResolver,
                },
                canDeactivate: [unsavedChangesGuard],
              },
              {
                path: 'update/:id/:versionId',
                runGuardsAndResolvers: 'always',
                component: CreateUpdatePackagingUnitComponent,
                resolve: {
                  packagingUnit: packagingUnitHistoryResolver,
                  changedComponentsIds: changedComponentsResolver,
                  permissions: packagingUnitPermissionsResolver,
                  isInOngoingDataExchange: getOngoingDataExchangeRequestsForPackagingUnitResolver,
                },
                canDeactivate: [unsavedChangesGuard],
              },
              ...PathResolveService.getAllPackagingUnitPreviewPaths().map(path => ({
                path,
                component: CreateUpdatePackagingUnitComponent,
                canDeactivate: [unsavedChangesGuard],
                resolve: {
                  packagingUnit: packagingUnitPreviewResolver,
                },
              })),
              {
                path: PathResolveService.getDataExchangeRequestPackagingUnitPath(),
                component: CreateUpdatePackagingUnitComponent,
                runGuardsAndResolvers: 'always',
                canDeactivate: [unsavedChangesGuard],
                data: { isDataExchangeSubRequest: true },
                resolve: {
                  dataExchangeRequest: dataExchangeRequestPackagingUnitResolver,
                },
              },
            ],
            resolve: {
              fillingGoods: fillingGoodsResolver,
              fillingGoodCategories: fillingGoodCategoriesResolver,
              fillingGoodTypes: fillingGoodTypesResolver,
              assemblyCountries: assemblyCountriesResolver,
              mainBodySubtypes: mainBodySubtypesResolver,
              closureSubtypes: closureSubtypesResolver,
              decorationSubtypes: decorationSubtypesResolver,
              inlaySubtypes: inlaySubtypesResolver,
              packagingAidSubtypes: packagingAidSubtypesResolver,
              removabilityConditions: removabilityConditionsResolver,
            },
          },
          {
            path: 'component',
            component: ComponentRoutingWrapperComponent,
            canActivate: [authGuard],
            children: [
              {
                path: '',
                redirectTo: PathResolveService.getComponentHomepagePath(),
                pathMatch: 'full',
              },
              {
                path: PathResolveService.getComponentHomepagePath(),
                component: ComponentHomeComponent,
                canActivate: [authGuard],
              },
              {
                path: PathResolveService.getComponentTypePath(),
                component: ComponentHomeComponent,
                canActivate: [authGuard],
              },
              {
                path: 'mainbody/create/:packagingType',
                component: CreateUpdateMainBodyComponent,
                canDeactivate: [unsavedChangesGuard],
              },
              {
                path: 'mainbody/create',
                component: CreateUpdateMainBodyComponent,
                canDeactivate: [unsavedChangesGuard],
              },
              {
                path: 'mainbody/update/:id',
                runGuardsAndResolvers: 'always',
                component: CreateUpdateMainBodyComponent,
                resolve: {
                  component: componentResolver,
                  permissions: componentPermissionsResolver,
                  isInOngoingDataExchange: getOngoingDataExchangeRequestsForPackagingComponentResolver,
                  isInternallyTracked: isComponentInternallyTrackedResolver,
                },
                canDeactivate: [unsavedChangesGuard],
              },
              {
                path: 'mainbody/update/:id/:versionId',
                runGuardsAndResolvers: 'always',
                component: CreateUpdateMainBodyComponent,
                resolve: {
                  component: componentHistoryResolver,
                  permissions: componentPermissionsResolver,
                  isInOngoingDataExchange: getOngoingDataExchangeRequestsForPackagingComponentResolver,
                  isInternallyTracked: isComponentInternallyTrackedResolver,
                },
                canDeactivate: [unsavedChangesGuard],
              },
              ...PathResolveService.getAllComponentPreviewPaths(MAIN_BODY_NAME).map(path => ({
                path,
                component: CreateUpdateMainBodyComponent,
                canDeactivate: [unsavedChangesGuard],
                resolve: {
                  component: componentPreviewResolver,
                },
              })),
              {
                path: PathResolveService.getDataExchangeRequestMainBodyPath(),
                component: CreateUpdateMainBodyComponent,
                runGuardsAndResolvers: 'always',
                canDeactivate: [unsavedChangesGuard],
                data: { isDataExchangeSubRequest: true },
                resolve: {
                  dataExchangeRequest: dataExchangeRequestPackagingComponentResolver,
                },
              },
              {
                path: 'closure/create',
                component: CreateUpdateClosureComponent,
                canDeactivate: [unsavedChangesGuard],
              },
              {
                path: 'closure/update/:id',
                runGuardsAndResolvers: 'always',
                component: CreateUpdateClosureComponent,
                resolve: {
                  component: componentResolver,
                  permissions: componentPermissionsResolver,
                  isInternallyTracked: isComponentInternallyTrackedResolver,
                  isInOngoingDataExchange: getOngoingDataExchangeRequestsForPackagingComponentResolver,
                },
                canDeactivate: [unsavedChangesGuard],
              },
              {
                path: 'closure/update/:id/:versionId',
                runGuardsAndResolvers: 'always',
                component: CreateUpdateClosureComponent,
                resolve: {
                  component: componentHistoryResolver,
                  permissions: componentPermissionsResolver,
                  isInternallyTracked: isComponentInternallyTrackedResolver,
                  isInOngoingDataExchange: getOngoingDataExchangeRequestsForPackagingComponentResolver,
                },
                canDeactivate: [unsavedChangesGuard],
              },
              ...PathResolveService.getAllComponentPreviewPaths(CLOSURE_NAME).map(path => ({
                path,
                component: CreateUpdateClosureComponent,
                canDeactivate: [unsavedChangesGuard],
                resolve: {
                  component: componentPreviewResolver,
                },
              })),
              {
                path: PathResolveService.getDataExchangeRequestClosurePath(),
                component: CreateUpdateClosureComponent,
                runGuardsAndResolvers: 'always',
                canDeactivate: [unsavedChangesGuard],
                data: { isDataExchangeSubRequest: true },
                resolve: {
                  dataExchangeRequest: dataExchangeRequestPackagingComponentResolver,
                },
              },
              {
                path: 'inlay/create',
                component: CreateUpdateInlayComponent,
                canDeactivate: [unsavedChangesGuard],
              },
              {
                path: 'inlay/update/:id',
                runGuardsAndResolvers: 'always',
                component: CreateUpdateInlayComponent,
                resolve: {
                  component: componentResolver,
                  permissions: componentPermissionsResolver,
                  isInternallyTracked: isComponentInternallyTrackedResolver,
                  isInOngoingDataExchange: getOngoingDataExchangeRequestsForPackagingComponentResolver,
                },
                canDeactivate: [unsavedChangesGuard],
              },
              {
                path: 'inlay/update/:id/:versionId',
                runGuardsAndResolvers: 'always',
                component: CreateUpdateInlayComponent,
                resolve: {
                  component: componentHistoryResolver,
                  permissions: componentPermissionsResolver,
                  isInternallyTracked: isComponentInternallyTrackedResolver,
                  isInOngoingDataExchange: getOngoingDataExchangeRequestsForPackagingComponentResolver,
                },
                canDeactivate: [unsavedChangesGuard],
              },
              ...PathResolveService.getAllComponentPreviewPaths(INLAY_NAME).map(path => ({
                path,
                component: CreateUpdateInlayComponent,
                canDeactivate: [unsavedChangesGuard],
                resolve: {
                  component: componentPreviewResolver,
                },
              })),
              {
                path: PathResolveService.getDataExchangeRequestInlayPath(),
                component: CreateUpdateInlayComponent,
                runGuardsAndResolvers: 'always',
                canDeactivate: [unsavedChangesGuard],
                data: { isDataExchangeSubRequest: true },
                resolve: {
                  dataExchangeRequest: dataExchangeRequestPackagingComponentResolver,
                },
              },
              {
                path: 'decoration/create',
                component: CreateUpdateDecorationComponent,
                canDeactivate: [unsavedChangesGuard],
              },
              {
                path: 'decoration/update/:id/:decorationType',
                runGuardsAndResolvers: 'always',
                component: CreateUpdateDecorationComponent,
                resolve: {
                  component: componentResolver,
                  permissions: componentPermissionsResolver,
                  isInternallyTracked: isComponentInternallyTrackedResolver,
                  isInOngoingDataExchange: getOngoingDataExchangeRequestsForPackagingComponentResolver,
                },
                canDeactivate: [unsavedChangesGuard],
              },
              {
                path: 'decoration/update/:id/:versionId/:decorationType',
                runGuardsAndResolvers: 'always',
                component: CreateUpdateDecorationComponent,
                resolve: {
                  component: componentHistoryResolver,
                  permissions: componentPermissionsResolver,
                  isInternallyTracked: isComponentInternallyTrackedResolver,
                  isInOngoingDataExchange: getOngoingDataExchangeRequestsForPackagingComponentResolver,
                },
                canDeactivate: [unsavedChangesGuard],
              },
              ...PathResolveService.getAllDecorationPreviewPaths(DECORATION_NAME).map(path => ({
                path,
                component: CreateUpdateDecorationComponent,
                canDeactivate: [unsavedChangesGuard],
                resolve: {
                  component: decorationPreviewResolver,
                },
              })),
              {
                path: PathResolveService.getDataExchangeRequestDecorationPath(),
                component: CreateUpdateDecorationComponent,
                runGuardsAndResolvers: 'always',
                canDeactivate: [unsavedChangesGuard],
                data: { isDataExchangeSubRequest: true },
                resolve: {
                  dataExchangeRequest: dataExchangeRequestPackagingComponentResolver,
                },
              },
              {
                path: 'packagingaid/create',
                component: CreateUpdatePackagingAidComponent,
                canDeactivate: [unsavedChangesGuard],
              },
              {
                path: 'packagingaid/update/:id',
                runGuardsAndResolvers: 'always',
                component: CreateUpdatePackagingAidComponent,
                resolve: {
                  component: componentResolver,
                  permissions: componentPermissionsResolver,
                  isInternallyTracked: isComponentInternallyTrackedResolver,
                  isInOngoingDataExchange: getOngoingDataExchangeRequestsForPackagingComponentResolver,
                },
                canDeactivate: [unsavedChangesGuard],
              },
              {
                path: 'packagingaid/update/:id/:versionId',
                runGuardsAndResolvers: 'always',
                component: CreateUpdatePackagingAidComponent,
                resolve: {
                  component: componentHistoryResolver,
                  permissions: componentPermissionsResolver,
                  isInternallyTracked: isComponentInternallyTrackedResolver,
                  isInOngoingDataExchange: getOngoingDataExchangeRequestsForPackagingComponentResolver,
                },
                canDeactivate: [unsavedChangesGuard],
              },
              ...PathResolveService.getAllComponentPreviewPaths(PACKAGING_AID_NAME).map(path => ({
                path,
                component: CreateUpdatePackagingAidComponent,
                canDeactivate: [unsavedChangesGuard],
                resolve: {
                  component: componentPreviewResolver,
                },
              })),
              {
                path: PathResolveService.getDataExchangeRequestPackagingAidPath(),
                component: CreateUpdatePackagingAidComponent,
                runGuardsAndResolvers: 'always',
                canDeactivate: [unsavedChangesGuard],
                data: { isDataExchangeSubRequest: true },
                resolve: {
                  dataExchangeRequest: dataExchangeRequestPackagingComponentResolver,
                },
              },
            ],
            resolve: {
              closureSubtypes: closureSubtypesResolver,
              decorationSubtypes: decorationSubtypesResolver,
              inlaySubtypes: inlaySubtypesResolver,
              packagingAidSubtypes: packagingAidSubtypesResolver,
              mainBodySubtypes: mainBodySubtypesResolver,
            },
          },
          {
            path: 'material',
            canActivate: [authGuard],
            children: [
              {
                path: '',
                redirectTo: PathResolveService.getMaterialHomepagePath(),
                pathMatch: 'full',
              },
              {
                path: PathResolveService.getMaterialHomepagePath(),
                component: MaterialHomeComponent,
                canActivate: [authGuard],
              },
              {
                path: 'create',
                component: CompositeMaterialComponent,
                canDeactivate: [unsavedChangesGuard],
              },
              {
                path: 'update/:id',
                runGuardsAndResolvers: 'always',
                component: CompositeMaterialComponent,
                resolve: {
                  compositeMaterial: compositeMaterialResolver,
                  isInternallyTracked: isMaterialInternallyTrackedResolver,
                  permissions: compositeMaterialPermissionsResolver,
                  isInOngoingDataExchange: getOngoingDataExchangeRequestsForMultiMaterialResolver,
                },
                canDeactivate: [unsavedChangesGuard],
              },
              {
                path: 'update/:id/:versionId',
                runGuardsAndResolvers: 'always',
                component: CompositeMaterialComponent,
                resolve: {
                  compositeMaterial: compositeMaterialHistoryResolver,
                  isInternallyTracked: isMaterialInternallyTrackedResolver,
                  permissions: compositeMaterialPermissionsResolver,
                  isInOngoingDataExchange: getOngoingDataExchangeRequestsForMultiMaterialResolver,
                },
                canDeactivate: [unsavedChangesGuard],
              },
              ...PathResolveService.getAllMaterialPreviewPaths().map(path => ({
                path,
                component: CompositeMaterialComponent,
                canDeactivate: [unsavedChangesGuard],
                resolve: {
                  compositeMaterial: compositeMaterialPreviewResolver,
                },
              })),
              {
                path: PathResolveService.getDataExchangeRequestMaterialPath(),
                component: CompositeMaterialComponent,
                runGuardsAndResolvers: 'always',
                canDeactivate: [unsavedChangesGuard],
                data: { isDataExchangeSubRequest: true },
                resolve: {
                  dataExchangeRequest: dataExchangeRequestMultiMaterialResolver,
                },
              },
            ],
          },
        ],
        resolve: {
          manufacturingCountries: manufacturingCountriesResolver,
          distributionCountries: distributionCountriesResolver,
          materialFunctions: materialFunctionsResolver,
          colors: colorsResolver,
          allManifestations: manifestationsResolver,
          rootDirectory: directoryResolver,
          allTags: allTagsResolver,
          certificateTypes: certificateTypesResolver,
        },
      },
      {
        path: PathResolveService.getRecyclabilityAnalysisHistoryPathUnit(),
        component: AnalysisRecyclabilityComponent,
        canActivate: [authGuard],
        resolve: {
          recyclabilityEvaluationHistoryResults: recyclabilityEvaluationHistoryResolverUnit,
          packagingUnit: packagingUnitHistoryResolver,
          recyclingStreams: recyclingStreamsResolver,
        },
      },
      {
        path: PathResolveService.getLifecycleAnalysisHistoryPathUnit(),
        component: AnalysisLifeCycleComponent,
        canActivate: [authGuard],
        resolve: {
          lifeCycleEvaluationHistoryResults: lifeCycleEvaluationHistoryResolverUnit,
          packagingUnit: packagingUnitHistoryResolver,
        },
      },
      {
        path: PathResolveService.getCradleToGateLifecycleAnalysisHistoryPathUnit(),
        component: AnalysisCradleToGateLifeCycleComponent,
        canActivate: [authGuard],
        resolve: {
          lifeCycleEvaluationHistoryResults: lifeCycleCradleToGateEvaluationHistoryResolverUnit,
          packagingUnit: packagingUnitHistoryResolver,
        },
      },
      {
        path: PathResolveService.getExpenseCalculationHistoryPathUnit(),
        component: ExpenseCalculationPackagingUnitComponent,
        canActivate: [authGuard],
        resolve: {
          expenseResults: expenseCalculationHistoryResolverUnit,
          packagingUnit: packagingUnitHistoryResolver,
          licenseFeeCountries: licenseFeeCountriesResolver,
          ecomodulationCountries: ecomodulationCountriesResolver,
          plasticTaxCountries: plasticTaxCountriesResolver,
        },
      },
      {
        path: PathResolveService.getExpenseCalculationHistoryPathSystem(),
        component: ExpenseCalculationPackagingSystemComponent,
        canActivate: [authGuard],
        resolve: {
          expenseResults: expenseCalculationHistoryResolverSystem,
          packagingUnit: packagingSystemHistoryResolver,
          licenseFeeCountries: licenseFeeCountriesResolver,
          ecomodulationCountries: ecomodulationCountriesResolver,
          plasticTaxCountries: plasticTaxCountriesResolver,
        },
      },
      {
        matcher: PathResolveService.comparisonPathMatcherUnits,
        component: ComparePackagingUnitsComponent,
        canActivate: [authGuard],
        resolve: {
          recyclabilityForComparison: recyclabilityComparisonResolverUnit,
          lcaForComparison: lcaComparisonResolverUnit,
          packagingUnits: multiplePackagingUnitsResolver,
          comparison: compareUnitsResolver,
        },
      },
      {
        path: PathResolveService.getRecyclabilityAnalysisHistoryPathSystem(),
        component: AnalysisRecyclabilityComponent,
        canActivate: [authGuard],
        resolve: {
          recyclabilityEvaluationHistoryResults: recyclabilityEvaluationHistoryResolverSystem,
          packagingSystem: packagingSystemHistoryResolver,
          recyclingStreams: recyclingStreamsResolver,
        },
      },
      {
        path: PathResolveService.getLifecycleAnalysisHistoryPathSystem(),
        component: AnalysisLifeCycleComponent,
        canActivate: [authGuard],
        resolve: {
          lifeCycleEvaluationHistoryResults: lifeCycleEvaluationHistoryResolverSystem,
          packagingSystem: packagingSystemHistoryResolver,
        },
      },
      {
        path: PathResolveService.getCradleToGateLifecycleAnalysisHistoryPathSystem(),
        component: AnalysisCradleToGateLifeCycleComponent,
        canActivate: [authGuard],
        resolve: {
          lifeCycleEvaluationHistoryResults: lifeCycleCradleToGateEvaluationHistoryResolverSystem,
          packagingSystem: packagingSystemHistoryResolver,
        },
      },
      {
        matcher: PathResolveService.comparisonPathMatcherSystems,
        component: ComparePackagingSystemsComponent,
        canActivate: [authGuard],
        resolve: {
          recyclabilityForComparison: recyclabilityComparisonResolverSystem,
          lcaForComparison: lcaComparisonResolverSystem,
          packagingSystems: multiplePackagingSystemsResolver,
        },
      },
      {
        path: PathResolveService.getErrorPath(),
        component: ErrorPageComponent,
        canActivate: [authGuard],
      },
    ],
    resolve: {
      packagingUnitTypes: packagingUnitTypesResolver,
      packagingUnitTypesEng: packagingUnitTypesEngResolver,
      componentTypes: componentTypesResolver,
      componentTypesEng: componentTypesEngResolver,
      decorationTypesEnglish: decorationSubtypesEngResolver,
      allCountries: allCountriesResolver,
      allCountriesEng: allCountriesEngResolver,
    },
  },
  {
    path: '**',
    component: ErrorPageComponent,
    canActivate: [authGuard],
    resolve: {
      path: errorPathResolver,
      errorCode: errorCodeResolver,
    },
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
